import React from 'react';
import Card from '../../ui/Card';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
const TrafficSourcesChart: React.FC = () => {
  const data = [{
    name: 'Organic Search',
    value: 77880,
    percentage: 42,
    color: '#10b981'
  }, {
    name: 'Paid Search',
    value: 55626,
    percentage: 30,
    color: '#3b82f6'
  }, {
    name: 'Direct',
    value: 27813,
    percentage: 15,
    color: '#f59e0b'
  }, {
    name: 'Social Media',
    value: 24101,
    percentage: 13,
    color: '#8b5cf6'
  }];
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className="font-bold text-sm" data-id="element-8121">
        {`${(percent * 100).toFixed(0)}%`}
      </text>;
  };
  return <Card className="p-6" data-id="element-8122">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-8123">
        Traffic Sources Breakdown
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-8124">
        Monthly visitor distribution by channel
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-8125">
        <PieChart data-id="element-8126">
          <Pie data={data} cx="50%" cy="50%" labelLine={false} label={renderCustomizedLabel} outerRadius={100} fill="#8884d8" dataKey="value" data-id="element-8127">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-8128" />)}
          </Pie>
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => value.toLocaleString()} data-id="element-8129" />
          <Legend verticalAlign="bottom" height={36} formatter={(value, entry: any) => <span className="text-sm text-gray-700" data-id="element-8131">
                {value}: {entry.payload.value.toLocaleString()} (
                {entry.payload.percentage}%)
              </span>} data-id="element-8130" />
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8132">
        <div className="grid grid-cols-2 gap-4" data-id="element-8133">
          {data.map((source, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-8134">
              <div className="flex items-center" data-id="element-8135">
                <div className="w-3 h-3 rounded-full mr-2" style={{
              backgroundColor: source.color
            }} data-id="element-8136" />
                <span className="text-gray-700" data-id="element-8137">{source.name}</span>
              </div>
              <span className="font-semibold text-gray-900" data-id="element-8138">
                {source.value.toLocaleString()}
              </span>
            </div>)}
        </div>
      </div>
    </Card>;
};
export default TrafficSourcesChart;